import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handleKeyDown2 } from '../utilities';
import { setCodpmpol, setErrorEncrypt, setFirstStep, setStateNotebook, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { Box, Button, Container, Fade, Modal, Stack, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import { createErrorEmail, saveTecnologyData } from '../redux/reducer/stepReducer/thunks';
import Spinner from './Spinner';
import dayjs from 'dayjs';

const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
};

export const Notebook = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { protectedNotebook, codpmpol, titularData, firstStep } = useSelector((state) => state.firstStep)

    const handleChange = (name, value) => {
        dispatch(setStateNotebook({ [name]: value }));
    };

    const onGoToPayment = async () => {
        if (!protectedNotebook.brand || protectedNotebook.brand.length < 2) {
            setModalIsOpen(true);
            return;
        }
        if (!protectedNotebook.model || protectedNotebook.model.length < 3) {
            setModalIsOpen(true);
            return;
        }
        setIsLoading(true);
        await dispatch(saveTecnologyData(protectedNotebook, codpmpol));
        setIsLoading(false);
        navigate('/pago');
    };

    useEffect(() => {
        handleChange('name', titularData.name);
        handleChange('lastname', titularData.lastname);
        handleChange('dni', titularData.dni);
        handleChange('birthdate', titularData.birthday);
    }, []);


    useEffect(() => {
        localStorage.setItem('dataNotebook', JSON.stringify(protectedNotebook));
    }, [protectedNotebook]);

    useEffect(() => {
        if (!codpmpol) {
            try {
                const getLocalDateStorage = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
                const storageCodpmpol = getLocalDateStorage();
                if (Array.isArray(storageCodpmpol)) {
                    let message = `Error Recid | Notebook Protegida | Intencion: ${firstStep.nro} | Seccion: ${firstStep.codsec} | Cod-Producto: ${firstStep.codpro}`
                    dispatch(createErrorEmail(message));
                    dispatch(setErrorEncrypt(true));
                    navigate('/error');
                } else {
                    dispatch(setCodpmpol(storageCodpmpol));
                    const dataFirstStep = JSON.parse(localStorage.getItem("firstStep"));
                    dispatch(setFirstStep({ ...firstStep, ...dataFirstStep }));
                    const dataTitular = JSON.parse(localStorage.getItem("titularData"));
                    dispatch(setTitularData({ ...titularData, ...dataTitular, birthday: dayjs(dataTitular.birthday).format('DD/MM/YYYY') }));
                    const dataNotebook = JSON.parse(localStorage.getItem("dataNotebook"));
                    handleChange('name', dataTitular.name);
                    handleChange('lastname', dataTitular.lastname);
                    handleChange('dni', dataTitular.dni);
                    handleChange('birthdate', dayjs(dataTitular.birthday).format('DD/MM/YYYY'));
                    handleChange('brand', dataNotebook.brand);
                    handleChange('model', dataNotebook.model);
                };
            }
            catch (error) {
                let message = `Error en Tecnologia Portatil | ${error}`;
                dispatch(createErrorEmail(message));
                dispatch(setErrorEncrypt(true))
                navigate('/error');
            };
        };
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = 'Estoy a punto de refrescarme';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <>
            {
                isLoading ?
                    <Spinner />
                    :
                    <Container style={{ paddingLeft: 6, paddingRight: 6, maxWidth: 280 }}>
                        <div style={{ marginTop: '20px' }}>
                            <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                <TextField
                                    error={protectedNotebook.brand.length > 0 && protectedNotebook.brand.length < 2}
                                    value={protectedNotebook.brand}
                                    label="Marca del producto"
                                    name='brand'
                                    onKeyDown={handleKeyDown2}
                                    onChange={({ target }) => {
                                        handleChange('brand', target.value.slice(0, 50).replace(/[^a-zA-Z0-9ñÑ\s]/g, ''));
                                    }}
                                    helperText={"Debe contener mínimo 2 caracteres"}
                                />
                            </Box>
                            <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                <TextField
                                    error={protectedNotebook.model.length > 0 && protectedNotebook.model.length < 3}
                                    value={protectedNotebook.model}
                                    label="Modelo del producto"
                                    name='model'
                                    onKeyDown={handleKeyDown2}
                                    onChange={({ target }) => {
                                        handleChange('model', target.value.slice(0, 50).replace(/[^a-zA-Z0-9ñÑ\s]/g, ''));
                                    }}
                                    helperText={"Debe contener mínimo 3 caracteres"} />
                            </Box>
                        </div>
                        <div className='contenedorBotones'>
                            <Stack spacing={1} direction="row">
                                <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="error" variant="outlined" onClick={() => navigate('/datosTitular')}>Atrás</Button>
                                <Button
                                    style={{ borderRadius: 20, textTransform: 'capitalize' }}
                                    size="medium"
                                    color="error"
                                    variant="contained"
                                    onClick={onGoToPayment}
                                >
                                    Continuar
                                </Button>
                            </Stack>
                        </div>
                        <Modal
                            open={modalIsOpen}
                            onClose={() => setModalIsOpen(false)}
                            closeAfterTransition
                        >
                            <Fade in={modalIsOpen}>
                                <Box sx={customStyles}>
                                    <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                                        Campos incompletos
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                                        Todos los campos son obligatorios, complete por favor los datos del asegurado.
                                    </Typography>
                                    <div
                                        className="contenedorBotones"
                                        style={{
                                            spacing: 9,
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: 13,
                                            position: "relative",
                                        }}
                                    >
                                        <Button
                                            style={{ borderRadius: 20, textTransform: "capitalize" }}
                                            size="medium"
                                            color="secondary"
                                            variant="contained"
                                            type="submit"
                                            onClick={() => setModalIsOpen(false)}
                                        >
                                            Aceptar
                                        </Button>
                                    </div>
                                </Box>
                            </Fade>
                        </Modal>
                    </Container>
            }
        </>
    )
}
